import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Donate_account_Add = () => {
  const navi=useNavigate()
  const [formData, setFormData] = useState({
    accountName: '',
    accountNumber: '',
    ifscNumber: '',
    branchName: '',
  });

  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

   
    if (!formData.accountName || !formData.accountNumber || !formData.ifscNumber || !formData.branchName) {
      setErrorMessage('All fields are required');
      return;
    }

    try {
    
      const response = await axios.post(`${process.env.REACT_APP_API}/addaccountdetails/addaccount`, formData);
      console.log('Form submitted successfully:');

    
      setFormData({
        accountName: '',
        accountNumber: '',
        ifscNumber: '',
        branchName: '',
      });

    
      setErrorMessage('');
    } catch (error) {
      setErrorMessage(error.response?.data?.message || 'Error submitting the form.');
      console.error('Error submitting the form:', error);
    }
    navi('/donate_account')
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <form
        onSubmit={handleSubmit}
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '50%',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <input
          type="text"
          id="accountName"
          placeholder="Account Name"
          value={formData.accountName}
          onChange={handleChange}
          style={{ padding: '8px', marginBottom: '10px', width: '50%' }}
        />

        <input
          type="text"
          id="accountNumber"
          placeholder="Account Number"
          maxLength={15}
          value={formData.accountNumber}
          onChange={(e) => {
    
            const newValue = e.target.value.replace(/[^0-9]/g, '');
            setFormData((prevData) => ({
              ...prevData,
              accountNumber: newValue,
            }));
          }}
          style={{ padding: '8px', marginBottom: '10px', width: '50%' }}
        />

        <input
          type="text"
          id="ifscNumber"
          placeholder="IFSC Number"
          value={formData.ifscNumber}
          onChange={handleChange}
          style={{ padding: '8px', marginBottom: '10px', width: '50%' }}
        />

        <input
          type="text"
          id="branchName"
          placeholder="Branch Name"
          value={formData.branchName}
          onChange={handleChange}
          style={{ padding: '8px', marginBottom: '10px', width: '50%' }}
        />

        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}

        <button
          type="submit"
          style={{
            padding: '10px 20px',
            backgroundColor: '#007BFF',
            color: '#fff',
            border: 'none',
            cursor: 'pointer',
            width: '30%',
            borderRadius: '10px',
          }}
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default Donate_account_Add;
